import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import TermsBarWeb from "./layouts/TermsBar.web";
import TermsBarMob from "./layouts/TermsBar.mob";

const TermsBarComponent = withConditionalComponent(TermsBarWeb, TermsBarMob);

const TermsBar: FC<{ terms: string; loading?: boolean }> = ({ terms, loading }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <TermsBarComponent trigger={isLargeScreen} props={{ terms, loading }} />;
};

export default TermsBar;
